import React from 'react';
import {Route, Switch} from 'react-router-dom';

import Intro from '../components/intro';

import {ROUTES} from '../config';
import Details from '../containers/details';
import Filters from '../containers/filters';
import List from '../containers/list';

const Content = () => (
	<Switch key="content">
		<Route key="content" path={ROUTES.DETAILS.path}>
			<div key="content" className="bsknacht17-content">
				<Filters key="filters" />
				<Details key="content" />
			</div>
		</Route>
		<Route key="content" path={ROUTES.LIST.path}>
			<div key="content" className="bsknacht17-content">
				<Filters key="filters" />
				<List key="content" />
			</div>
		</Route>
		<Route key="content" path={ROUTES.INTRO.path}>
			<div className="bsknacht17-content">
				<Intro />
			</div>
		</Route>
	</Switch>
);

export default Content;
